/**
 * @author Nihar <nihar.baishya@314ecorp.com>
 * @description View Eligibility Response
 */

import { Link } from 'react-router-dom';

import TypographyWithTooltip from 'components/common/TypographyWithTooltip';
import { getClaimEligibilityPath, getEligibilityResponsePath } from 'utils/router';
import { useAppStoreValues } from 'store/app';

export interface IProps {
	data: EligibilityRequests.IEligibilityData;
}

const ViewEligibilityResponse: React.FC<IProps> = ({ data }) => {
	const { isARCustomer } = useAppStoreValues().userAccess;
	if (!data?.responseId) {
		return <TypographyWithTooltip content={data?.eligibilityId} />;
	}

	const redirectPath = isARCustomer ? getClaimEligibilityPath(data?.responseId) : getEligibilityResponsePath(data?.responseId);
	return <TypographyWithTooltip content={<Link to={redirectPath}>{data?.eligibilityId}</Link>} showArrow />;
};

export default ViewEligibilityResponse;
